import { heroStats } from "@/mocks/homeContent";

export default function Hero() {
  return (
    <section id="top" className="relative w-full">
      <div className="relative w-full h-[560px] md:h-[660px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20cinematic%20dark%20backdrop%20with%20glowing%20warm%20amber%20and%20crimson%20light%20streaks%2C%20floating%20film%20grain%20particles%20and%20bokeh%20orbs%2C%20deep%20charcoal%20tones%2C%20elegant%20artistic%20movie%20theater%20atmosphere%2C%20no%20text%2C%20high%20detail%2C%20harmonious%20composition&width=1920&height=1080&seq=starfilm-hero-2026&orientation=landscape"
          alt="星辰影视客户端播放界面氛围背景"
          className="absolute inset-0 w-full h-full object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

        <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-8">
          <span className="inline-flex items-center gap-2 bg-background-50/15 text-background-50 text-xs md:text-sm px-4 py-1.5 rounded-full font-label tracking-wide">
            <i className="ri-download-cloud-2-line"></i>
            手机版 · TV 版 · 网页版 官方下载页
          </span>

          <h1 className="mt-5 font-heading text-3xl md:text-6xl font-bold text-background-50 leading-tight max-w-4xl">
            星辰影视客户端与 App 下载安装指南
          </h1>

          <p className="mt-5 text-sm md:text-lg text-background-100/90 max-w-2xl leading-relaxed">
            本页集中提供星辰影视手机版、tv 版安装包的获取方式与安装步骤，
            覆盖安卓、iOS、智能电视与电脑多类设备，跟着步骤操作即可快速完成安装。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
            <a
              href="#mobile"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 text-sm md:text-base px-6 py-3 rounded-md cursor-pointer whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-smartphone-line"></i>
              获取手机版安装包
            </a>
            <a
              href="#tv"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-background-50/10 border border-background-50/40 text-background-50 text-sm md:text-base px-6 py-3 rounded-md cursor-pointer whitespace-nowrap hover:bg-background-50/20 transition-colors"
            >
              <i className="ri-tv-2-line"></i>
              获取 TV 版安装包
            </a>
          </div>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 -mt-12 relative z-20">
        <div className="max-w-6xl mx-auto bg-background-50 rounded-xl border border-background-200 px-4 md:px-8 py-6 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {heroStats.map((stat) => (
            <div key={stat.id} className="flex flex-col items-center text-center gap-1">
              <span className="font-heading text-xl md:text-3xl font-bold text-primary-600">
                {stat.value}
              </span>
              <span className="text-xs md:text-sm text-foreground-600">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}